import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Rental } from '../../models/rental.model';
import { LandlordService } from 'src/app/services/landlord.service';
import { RentalService } from 'src/app/services/rental.service';
import { ImageUploadService } from 'src/app/services/image-upload.service';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import {
  ClassicEditor,
  Bold,
  Essentials,
  Heading,
  Italic,
  Link,
  List,
  Paragraph,
  Undo
} from 'ckeditor5';

import 'ckeditor5/ckeditor5.css';

@Component({
  selector: 'app-rental-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule,CKEditorModule],
  templateUrl: './rental-form.component.html'
})
export class RentalFormComponent implements OnInit {
  @Input() rental?: Rental;              // 👈 edit mode
  @Input() submitting = false;
  @Output() save = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();
  landlords: any[] = [];
  form!: FormGroup;
  selectedFiles: File[] = [];
previewUrls: string[] = [];
public Editor = ClassicEditor;

  public editorConfig = {
    licenseKey: 'GPL',

    plugins: [
      Essentials,
      Paragraph,
      Heading,
      Bold,
      Italic,
      Link,
      List,
      Undo
    ],

    toolbar: [
      'undo',
      'redo',
      '|',
      'heading',
      '|',
      'bold',
      'italic',
      '|',
      'link',
      '|',
      'bulletedList',
      'numberedList'
    ],

    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph'
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Heading 2',
          class: 'ck-heading_heading2'
        },
        {
          model: 'heading3',
          view: 'h3',
          title: 'Heading 3',
          class: 'ck-heading_heading3'
        }
      ]
    }
  };
  constructor(private fb: FormBuilder,private landlordService: LandlordService,private rentalService: RentalService,private imageUploadService: ImageUploadService) {}

  ngOnInit() {
    this.form = this.fb.group({
      landlordId: ['', Validators.required],
      title: ['', Validators.required],
      address: ['', Validators.required],
      price: [0, Validators.required],
      description: [''],

      bedrooms: [0],
      bathrooms: [0],
      sqft: [0],
      deposit: [0],
      leaseTerm: [12],
      availableDate: [''],

      utilitiesIncluded: [false],
      petPolicy: [''],

      status: ['pending', Validators.required], // ✅ status wired
      notes: ['']
    });

    if (this.rental) {
      this.form.patchValue(this.rental);
    }
    this.loadLandlords();

  if (this.rental) {
    this.form.patchValue(this.rental);
  }
  }
loadLandlords() {
  this.landlordService.getLandlords().subscribe(users => {
    this.landlords = users;
  });
}
removeImage(url: string) {
    this.rental.images = this.rental.images.filter(img => img !== url);
  }

async openRound() {
  if (!this.rental?.id) return;

  const roundId = await this.rentalService.openApplicationRound(this.rental.id);

  this.rental.activeRoundId = roundId;
  this.form.patchValue({ status: 'available' });
}

async closeRound() {
  if (!this.rental?.activeRoundId) return;

  await this.rentalService.closeApplicationRound(this.rental.activeRoundId);

  this.rental.activeRoundId = null;
}
onFileSelected(event: any) {

  const files: FileList = event.target.files;

  this.selectedFiles = Array.from(files);

  this.previewUrls = this.selectedFiles.map(file =>
    URL.createObjectURL(file)
  );
}

 async submit() {

     if (this.form.invalid) {
    console.log("FORM INVALID", this.form);
    return;
  }

    let uploadedImages: string[] = [];

    // Upload new images first
    if (this.selectedFiles && this.selectedFiles.length > 0) {
      uploadedImages = await this.imageUploadService.uploadImages(this.selectedFiles);
    }

    const payload = {
      ...this.form.value,
      images: [
        ...(this.rental?.images || []),
        ...uploadedImages
      ]
    };

    // Emit AFTER uploads complete
    this.save.emit(payload);
  }
}
